<template>
  <v-app>
    <v-app-bar
        app
        dark
        flat
        color="primary"
    >
      <div class="d-flex align-center">
        <v-img
            alt="Vuetify Logo"
            class="shrink mr-2"
            contain
            src="/wlogo.png"
            transition="scale-transition"
            width="120"
        />
      </div>
      <v-spacer></v-spacer>
      <div v-if="isLoggedIn ">
        <v-btn to="/mi-cuenta" text>
          {{ $t('Mi Cuenta') }}
        </v-btn>
        <v-btn v-if="isAdmin" to="/eventos/admin" text>
          {{ $t('Eventos') }}
        </v-btn>
        <v-btn v-else to="/eventos" text>
          {{ $t('Eventos') }}
        </v-btn>
        <v-btn v-if="isAdmin" to="/bodegas" text>
          {{ $t('Bodegas') }}
        </v-btn>
        <v-btn v-else-if="$store.state.bodega == 0" to="/bodega" text>
          {{ $t('Añadir mi bodega') }}
        </v-btn>
        <v-btn v-else :to="{ name: 'bodegaid', params: { id: $store.state.bodega }}" text>
          {{ $t('Editar mi bodega') }}
        </v-btn>


        <v-menu open-on-hover offset-y transition="slide-x-transition" bottom right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn  v-bind="attrs" v-on="on" text>
             {{ $t('DESCARGABLES') }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in items" :key="index" router :to="item.link">
              <v-list-item-action>
                <router-link :to="{name:'archivos',params:{id:item.id}}">{{ $t(item.title) }}</router-link>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-menu>


        <v-btn
               color="primary"
               elevation="0"
               to="/salir"
        >
          {{ $t('Salir') }}
        </v-btn>
      </div>
      <v-app-bar-nav-icon v-if="false"></v-app-bar-nav-icon>
    </v-app-bar>
    <v-main>
      <transition
          name="fade"
          mode="out-in"
      >
        <router-view/>
      </transition>

      <v-snackbar v-model="showmessage" :centered="true" :timeout="6000" :color="color">
        {{ message }}
<!--        <v-btn text @click="showmessage = false">Close</v-btn>-->
      </v-snackbar>

    </v-main>
  </v-app>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: 'App',

  data: () => ({
    "showmessage": false,
    "message": false,
    "color": "",
    items: [
        { title: 'Memoria de actividades', id:1 },
        { title: 'Imagenes', id:2 },
        { title: 'Logotipos D.O. Cava', id:3 },
        { title: 'Presentaciones / Estadísticas', id:4 }
      ]
  }),
  computed: {
    ...mapGetters([
      "isAdmin", "isLoggedIn"
    ])
  },
  watch: {
    '$store.state.hash': function () {
      this.showmessage = true
      this.message = this.$store.state.content
      this.color = this.$store.state.color

    }
  },
  methods: {
    isMobile() {
      return false
      if (this.$vuetify.breakpoint.mobile) {
        return true
      }
      return false;
    }
  }
};
</script>

<style>
h1 {
  font-family: Loro;
  font-size: 50px;
  padding-top: 30px;
  padding-bottom: 30px;
}

* {
  font-family: "Open Sans";
}

h4 {
  color: #67833D !important;
  margin-left: -10px;
  font-weight: normal;
  text-transform: uppercase;
  font-size: 15px;
  padding-top: 40px
}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .1s;
}

.fade-enter-active {
  transition-delay: .01s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

</style>
